/* istanbul ignore file */

export const AUTH_STORAGE_KEYS = {
    AUTHENTICATED: 'authenticated',
    RETURN_URL: 'returnUrl',
    ROUTED_APP: 'routedApp',
    IDENTITY_PROVIDER_TYPE: 'identityProviderType'
} as const;

export const AUTH_PROVIDER_TYPES = {
    ENTRA_ID: 'EntraId',
    ENTRA_EXTERNAL_ID: 'EntraExternalId',
    UNKNOWN: 'Unknown'
} as const;

export const AUTH_ROUTES = {
    HOME: 'home',
    PLATFORM_USER_APPS: ['platform', 'user-apps'] as string[],
    ACCOUNT_MAPPING_FAILED: 'account-mapping-failed'

} as const;

export const AUTH_MESSAGES = {
    AUTH_SUCCESS: 'Authenticated successfully.',
    AUTH_FAILED: 'Authentication failed. Please try again.',
    LOGIN_FAILED: 'The login failed. Please try again.',
    EMAIL_VALIDATION_ERROR: 'Error validating email',
    PHONE_VALIDATION_ERROR: 'Error validating phone number',
    ACCOUNT_DISABLED: 'Your account is disabled, cannot log in',
    NO_ACCOUNT: 'No account found, please request access.',
    USER_LOAD_ERROR: 'Error loading user data.',
    STORAGE_PARSE_ERROR: 'Failed to parse authentication state from storage:',
    CLOSE_BUTTON: 'Close'
} as const;

export const AUTH_ERROR_CODES = {
    AUTHORITY_MISMATCH: 'authority_mismatch'
} as const;

export const AUTH_CONSOLE_MESSAGES = {
    INIT_STORAGE_ERROR: 'Error initializing identity provider from storage:',
    REDIRECT_PROMISE_ERROR: 'Error handling redirect promise:',
    REDIRECT_TOKEN_ERROR: 'Error acquiring token from redirect:',
    SILENT_TOKEN_ERROR: 'Error acquiring token silently:',
    AUTHORITY_MISMATCH_WARNING: 'Authority mismatch detected - clearing cached accounts and resetting identity provider',
    CLEAR_CACHE_ERROR: 'Error clearing cached accounts:',
    AUTHENTICATION_FAILED: 'Authentication failed:',
    INTERACTION_REQUIRED: 'Interaction required to acquire token.',
} as const;
